import { createRouter, createWebHistory } from 'vue-router'
// import Home from '../pages/home.vue'
import home from '@/pages/home.vue'
import Microeconomics from '@/pages/Microeconomics.vue'
import Biology from '@/pages/Biology.vue'
import Physics1 from '@/pages/Physics1.vue'
import Csp from '@/pages/Csp.vue'
import Macroeconomics from '@/pages/Macroeconomics.vue'
import CaIculusbc from '@/pages/CaIculusbc.vue'
import DetailPdf from '@/pages/Detail-pdf.vue'
import Aboutus from '@/pages/Aboutus.vue'
import  Videosd from '@/pages/Videosd.vue'
import Middlepdf from '@/pages/middle-pdf.vue'
import Middlevideo from '@/pages/middle-video.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
 
  },
  {
    path: '/microeconomics',
    name: 'Microeconomics',
    component: Microeconomics
  },
  {
    path: '/biology',
    name: 'Biology',
    component: Biology
  },
  {
    path: '/physics1',
    name: 'Physics1y',
    component: Physics1
  },
  {
    path: '/csp',
    name: 'Csp',
    component: Csp
  },
  {
    path: '/macroeconomics',
    name: 'Macroeconomics',
    component: Macroeconomics
  },
  {
    path: '/calculusbc',
    name: 'Calculusbc',
    component: CaIculusbc
  },
  {
    path: '/detail-pdf',
    name: 'DetailPdf',
    component: DetailPdf
  },
  {
    path: '/aboutus',
    name: 'Aboutus',
    component: Aboutus
  },
  {
    path: '/videosd',
    name: 'Videosd',
    component: Videosd
  },
  {
    path: '/middlepdf',
    name: 'Middlepdf',
    component: Middlepdf
  },
  {
    path: '/middlevideo',
    name: 'Middlevideo',
    component: Middlevideo
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router